module.exports = __webpack_public_path__ + "static/media/29ADMSPC30.882ca112.jpg";